import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { setActiveTab, singleSchedaSpeseGet } from "../features/schedaSpese/schedaSpeseSlice";
import { getAllCategories } from "../features/categorie/categorieSlice";
import { FaArrowLeft } from "react-icons/fa";

import Spinner from "../components/utils/Spinner";
import SingleSchedaAllNote from "../components/SingleSchedaAllNote";

import SingleSchedaAllNoteNew from "../components/SingleSchedaAllNote.refactored";

function SchedaSpesaDettaglio() {
  const { id, scope } = useParams();
  const dispatch = useDispatch();
  const scopeFromUrl = scope === "personal" ? "personal" : "shared";

  const singleScheda = useSelector(
    (state) => state.schedaSpese.singleSchedaSpese
  );

  const { categorie, isLoading: categorieLoading } = useSelector((state) => state.categorie);

  useEffect(() => {
    dispatch(setActiveTab(scopeFromUrl));
  }, [scopeFromUrl, dispatch]);

  useEffect(() => {
    if (!id) return;
    dispatch(singleSchedaSpeseGet(id))
      .unwrap()
      .catch((error) => console.error("Error fetching single scheda:", error));
  }, [id, dispatch]);

  // Only fetch if not already loaded elsewhere (e.g. the schede list page).
  useEffect(() => {
    if (categorie.length === 0 && !categorieLoading) {
      dispatch(getAllCategories());
    }
  }, [categorie.length, categorieLoading, dispatch]);

  const navigateBack = () => {
    window.history.back();
  };

  return (
    <>
      <div className="container ">
        <div className="row">
          <div className="col-12 col-lg-12 mx-auto">
            <div className="d-flex align-items-center mb-4 mt-0">
              <FaArrowLeft
                className="mb-0 me-3"
                onClick={() => navigateBack()}
              />

              <h2 className="mb-0 align-self-center">Expense detail</h2>
            </div>

            <div>
              {singleScheda && categorie? (
                <SingleSchedaAllNoteNew
                  key={singleScheda._id}
                  scheda={singleScheda}
                  categorie={categorie}
                  listScope={scopeFromUrl}
                />
              ) : (
                <>
                  <Spinner />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SchedaSpesaDettaglio;
